import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const DropdownArrowRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 16.5858C9 17.4767 10.0771 17.9229 10.7071 17.2929L15.2929 12.7071C15.6834 12.3166 15.6834 11.6834 15.2929 11.2929L10.7071 6.70711C10.0771 6.07714 9 6.52331 9 7.41421L9 16.5858Z"
          fill="black"
        />
      </svg>
    )
  },
)
